import { useEffect, useState } from 'react';

// A PLACE IN THE DESKTOP SIDEBAR THAT A PAGE CAN FILL — under the navigation — for a control
// about what the page has open (the reader's submodel). The sidebar draws an empty box with
// this id; the page portals into it. Found once the layout has mounted, which it has by the
// time a page's effects run.
export const SIDEBAR_SLOT_ID = 'sidebar-slot';
// AND ONE AT THE BOTTOM of the rail, over the language toggle — for what belongs to the page
// without being part of its navigation (the Blender add-on).
export const SIDEBAR_FOOT_ID = 'sidebar-foot';

// Any element by id, once mounted — the sidebar's two, and a phase's own (see GENERATE_SLOT_ID).
export function useSlot(id: string = SIDEBAR_SLOT_ID): HTMLElement | null {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  useEffect(() => setSlot(document.getElementById(id)), [id]);
  return slot;
}
